<template>
    <div class="vx-row">
        <div class="vx-col md:w-4/4 w-full mb-base">
            <vx-card>
                <!-- Merchant -->
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/6 w-full">
                        <span>Merchant</span>
                    </div>
                    <div class="vx-col sm:w-2/5 w-full">
                        <v-select id="cbo-merchant" inputId="txt-device" v-model="selected_merchant"
                            placeholder="Select merchant" :options="merchant_list">
                        </v-select>
                    </div>
                </div>
                <!-- Device Type -->
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/6 w-full">
                        <span>Device Type</span>
                    </div>
                    <div class="vx-col sm:w-2/5 w-full">
                        <v-select autocomplete v-model="selected_type" placeholder="Select device type"
                            :options="device_type">
                        </v-select>
                    </div>
                </div>

                <!-- Quantity -->
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/6 w-full">
                        <span>Device Quantity</span>
                    </div>
                    <div class="vx-col sm:w-2/5 w-full">
                        <vs-input v-model="device_quantity" id="txt-quantity" type="number"
                            placeholder="Device quantity" class="w-full" />
                    </div>
                </div>

                <!-- Button -->
                <div class="vx-row mb-6" v-if="isHidden">
                    <div class="vx-col sm:w-1/6 w-full">
                        <span>&nbsp;</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-button id="btn-filter" :hidden="disabled_button" icon-pack="feather" icon="icon-plus"
                            v-on:click="submitRequest(1, 10)" class="mr-3 mb-2 float-left">Submit Request Device
                        </vs-button>
                    </div>
                </div>

                <!-- Request Code -->
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/6 w-full">
                    </div>
                    <div class="vx-col sm:w-2/5 w-full">
                        <vs-input v-model="device_request_code" id="txt-device-request-code" type="text" disabled
                            placeholder="Device request code" class="w-full" />
                    </div>
                </div>
            </vx-card>
        </div>

        <vx-card>
            <!-- TABLE ACTION ROW -->
            <div class="flex flex-wrap justify-between items-center">
                <!-- ITEMS PER PAGE -->
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * limit - (limit - 1) }} - {{ dataCount - currentPage *
                                    limit > 0 ? currentPage * limit : dataCount
                            }} of {{ dataCount }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                        <vs-dropdown-menu id="ddl-page-limit">
                            <vs-dropdown-item id="ddl-page-limit-1" @click="fetchData(1, 20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-2" @click="fetchData(1, 50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-3" @click="fetchData(1, 100)">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-4" @click="fetchData(1, 150)">
                                <span>150</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-5" @click="fetchData(1, totalData)">
                                <span>Show All</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <ag-grid-vue :gridOptions="gridOptions" class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="dataDevice" rowSelection="multiple"
                colResizeDefault="shift" :animateRows="true" :floatingFilter="true" :pagination="true"
                :paginationPageSize="limit" :suppressPaginationPanel="true" :enableCellTextSelection="true">
            </ag-grid-vue>
            <vs-pagination :total="totalPage" :max="maxPageNumbers" v-model="currentPage" />
        </vx-card>

    </div>
</template>

<script>
import vSelect from 'vue-select';
import 'flatpickr/dist/flatpickr.css';
import { url } from "@/configs/apiUrl";
import { AgGridVue } from "ag-grid-vue";
import 'vue-simple-suggest/dist/styles.css';
import AxiosCall from "@/global/AxiosCall";
import flatPickr from 'vue-flatpickr-component';
import VueSimpleSuggest from 'vue-simple-suggest';
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import StatusAgGridComponent from "./DeviceRequestStatus"
import ScanAgGridComponent from "./DeviceRequestScan"
import GetConfigAgGridComponent from "./DeviceRequestGetConfig"
import ShowQRAgGridComponent from "./DeviceRequestShowQR"
import PopUpAgGridComponent from "./DeviceRequestPopUp"
import EditSerialNumber from "./DeviceRequestSerialNumber"

export default {
    components: {
        AgGridVue,
        flatPickr,
        'v-select': vSelect,
        VueSimpleSuggest,
    },
    data() {
        return {
            merchant_list: [],
            device_type: [],
            selected_type: null,
            selected_type_id: null,
            selected_merchant: null,
            device_quantity: null,
            device_request_code: null,
            disabled_button: false,
            config_device: false,
            model: null,
            mode: 'input',
            loading: false,
            searchQuery: "",
            isHidden: true,
            gridOptions: {
                rowHeight: 75,
                getRowNodeId: data => data.id,
            },
            maxPageNumbers: 7,
            gridApi: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                autoHeight: true,
                suppressMenu: true,
                filterParams: {
                    applyButton: true,
                    newRowsAction: 'keep'
                },
            },
            columnDefs: [
                {
                    headerName: "Device Code",
                    field: "code",
                    width: 155,
                    filter: true,
                    editable: false,
                },
                {
                    headerName: "Status",
                    field: "status_provision",
                    width: 95,
                    filter: true,
                    editable: false,
                    cellRendererFramework: StatusAgGridComponent,
                },
                {
                    headerName: "Scan",
                    field: "code",
                    width: 125,
                    filter: false,
                    editable: false,
                    cellRendererFramework: ScanAgGridComponent,
                },
                {
                    headerName: "Serial Number",
                    field: "serial_number",
                    width: 200,
                    filter: true,
                    editable: true,
                },
                {
                    headerName: "Change SN",
                    field: "serial_number",
                    width: 200,
                    filter: false,
                    editable: false,
                    cellRendererFramework: EditSerialNumber,
                },
                {
                    headerName: "Get Config",
                    field: "serial_number",
                    width: 150,
                    filter: false,
                    editable: false,
                    cellRendererFramework: GetConfigAgGridComponent,
                },
                {
                    headerName: "QR Config",
                    field: "qr_config",
                    width: 150,
                    filter: false,
                    editable: false,
                    cellRendererFramework: ShowQRAgGridComponent,
                },
                {
                    headerName: "Setup Config",
                    field: "qr_config",
                    width: 500,
                    filter: false,
                    editable: false,
                    wrapText: true,
                    cellClass: 'text-small',
                    cellRendererFramework: PopUpAgGridComponent,
                },
            ],
            dataDevice: [],
            dataCount: 0,
            totalPage: 0,
            page: 1,
            limit: 10,
            totalData: 1,
            isFilter: false,
            deviceType: null,
        };
    },
    computed: {
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1;
            },
            set(val) {
                this.fetchData(val, this.limit);
            }
        }
    },
    methods: {
        openLoading() {
            this.$vs.loading({
                type: "default"
            });
        },
        updateSerial(data) {
            console.log("WWW", data)
            var rowNode = this.gridApi.getRowNode(data.index);
            rowNode.setDataValue('serial_number', data.value)
        },
        updateSerialNumber(data) {
            let payload = {
                device_type_id: this.selected_type_id,
                serial_number: data.serial_number,
                user_action: data.data.user_action,
            }
            if (this.config_device === false) {
                this.config_device = true
                AxiosCall.Post(url.svd.device.store, payload).then(response => {
                    if (response.code == 200) {
                        let payload = {
                            serial_number: data.serial_number,
                            device_type: this.deviceType,
                            code: data.data.code
                        }
                        let id_device = data.data.id
                        AxiosCall.Put(url.svd.device_request_new.update_serial_number + "/" + id_device, payload).then(response => {
                            if (response.code == 200) {
                                var rowNode = this.gridApi.getRowNode(data.index);
                                rowNode.setDataValue('qr_config', data.value)
                            }
                            this.config_device = false
                        }, error => {
                            this.config_device = false
                            if (error.response.status == 400)
                                this.$vs.notify({
                                    title: "Warning",
                                    text: error.response.data.message,
                                    iconPack: "feather",
                                    icon: "icon-alert-circle",
                                    color: "warning",
                                    position: "top-right"
                                })
                        })
                        this.fetchData(1, 20)
                    }
                }, error => {
                    this.config_device = false
                    if (error.response.status == 400) {
                        let payload = {
                            serial_number: data.serial_number,
                            device_type: this.deviceType,
                            code: data.data.code
                        }
                        let id_device = data.data.id
                        AxiosCall.Put(url.svd.device_request_new.update_serial_number + "/" + id_device, payload).then(response => {
                            if (response.code == 200) {
                                var rowNode = this.gridApi.getRowNode(data.index);
                                rowNode.setDataValue('qr_config', data.value)
                            }
                            this.config_device = false
                        }, error => {
                            this.config_device = false
                            this.$vs.notify({
                                title: "Warning",
                                text: error.response.data.message,
                                iconPack: "feather",
                                icon: "icon-alert-circle",
                                color: "warning",
                                position: "top-right"
                            })
                        })
                        this.fetchData(1, 20)
                    }
                })
            }
            this.fetchData(1, 20)
        },
        updateConfig(data) {
            let payload = {
                device_type_id: this.selected_type_id,
                serial_number: data.data.serial_number,
                user_action: data.data.user_action,
            }
            if (this.config_device === false) {
                this.config_device = true
                AxiosCall.Post(url.svd.device.store, payload).then(response => {
                    if (response.code == 200) {
                        let payload = {
                            serial_number: data.data.serial_number,
                            device_type: this.deviceType,
                            code: data.data.code
                        }
                        let id_device = data.data.id
                        AxiosCall.Put(url.svd.device_request_new.update_serial_number + "/" + id_device, payload).then(response => {
                            if (response.code == 200) {
                                var rowNode = this.gridApi.getRowNode(data.index);
                                rowNode.setDataValue('qr_config', data.value)
                            }
                            this.config_device = false
                        }, error => {
                            this.config_device = false
                            if (error.response.status == 400)
                                this.$vs.notify({
                                    title: "Warning",
                                    text: error.response.data.message,
                                    iconPack: "feather",
                                    icon: "icon-alert-circle",
                                    color: "warning",
                                    position: "top-right"
                                })
                        })
                    }
                }, error => {
                    this.config_device = false
                    if (error.response.status == 400) {
                        let payload = {
                            serial_number: data.data.serial_number,
                            device_type: this.deviceType,
                            code: data.data.code
                        }
                        let id_device = data.data.id
                        AxiosCall.Put(url.svd.device_request_new.update_serial_number + "/" + id_device, payload).then(response => {
                            if (response.code == 200) {
                                var rowNode = this.gridApi.getRowNode(data.index);
                                rowNode.setDataValue('qr_config', data.value)
                            }
                            this.config_device = false
                        }, error => {
                            this.config_device = false
                            this.$vs.notify({
                                title: "Warning",
                                text: error.response.data.message,
                                iconPack: "feather",
                                icon: "icon-alert-circle",
                                color: "warning",
                                position: "top-right"
                            })
                        })
                    }
                })
            }
        },
        fetchData(page, limit) {
            let newUrl = url.svd.device_request_new.list + "/" + this.device_request_code + "?page=" + page + "&limit=" + limit
            this.openLoading();
            AxiosCall.Get(newUrl).then(res => {
                this.dataDevice = [];
                this.dataCount = 0
                this.totalPage = 0
                if (res.data.data.length !== 0) {
                    let total = parseInt(res.data.total)
                    this.totalData = total
                    let no = ((page - 1) * limit) + 1;
                    for (let data of res.data.data) {
                        data.no = no;
                        this.deviceType = data.device_request.device_type_id;
                        if (data.serial_number) {
                            if (!data.config.user) {
                                let hexstring = parseInt(Date.parse(data.created_at), 10).toString(16);
                                data.qr_config = "AINO#0#" + data.serial_number + `#` + hexstring + "#" + data.enc
                            } else {
                                data.qr_config = "AINO#0#" + data.serial_number + `#{"email":"` + data.config.user.email + `","password":"` + data.config.user.password + `","code":"` + data.code + `", "serial_number":"` + data.serial_number + `"}`
                            }
                        } else {
                            data.qr_config = null
                        }
                        this.dataDevice.push(data);
                        no++
                    }

                    this.dataCount = total;
                    this.page = page;
                    if (limit >= this.dataCount) {
                        this.limit = this.dataDevice.length
                    } else {
                        this.limit = limit;
                    }

                    this.gridApi.paginationSetPageSize(this.limit);
                    if (this.$route.path !== '/device/request-devices/add') {
                        this.selected_type_id = res.data.data[0].device_request.device_type_id
                    }
                    this.totalPage = res.data.lastPage;
                } else {
                    this.totalData = parseInt(res.data.data.length)
                }
                this.$vs.loading.close();

            })
                .catch(e => {
                    this.$vs.loading.close();
                    console.log(e);
                });

        },
        submitRequest() {
            if (this.selected_merchant === null) {
                this.$vs.notify({
                    title: "Warning",
                    text: "Please select device type from the list!",
                    color: "warning",
                    position: "top-right"
                })
            } else if (this.selected_type === null) {
                this.$vs.notify({
                    title: "Warning",
                    text: "Please select file!",
                    color: "warning",
                    position: "top-right"
                })
            } else if (this.device_quantity === null) {
                this.$vs.notify({
                    title: "Warning",
                    text: "Please select file!",
                    color: "warning",
                    position: "top-right"
                })
            } else {
                this.$vs.loading({
                    type: "radius"
                })

                let payload = {};
                payload.merchant_id = this.selected_merchant.id
                payload.device_type_id = this.selected_type.id;
                payload.device_qty = parseInt(this.device_quantity);

                AxiosCall.Post(url.svd.device_request_new.store, payload).then(response => {
                    if (response.code == 200) {
                        this.device_request_code = response.data.merchant_device_request.code
                        this.$vs.loading.close()
                        this.$router.push({ path: "/device/request-devices/" + response.data.merchant_device_request.code })
                        this.fetchData(1, 10)
                    }
                }, error => {
                    console.log(error.response)
                    this.$vs.loading.close()
                    if (error.response.status == 400)
                        this.$vs.notify({
                            title: "Warning",
                            text: error.response.data.message,
                            iconPack: "feather",
                            icon: "icon-alert-circle",
                            color: "warning",
                            position: "top-right"
                        })
                })
            }
        },
        createNew() {
            this.$router.push({ path: "/device/request-devices/add" });
        },
    },
    mounted() {
        if (this.$route.path !== '/device/request-devices/add') {
            this.device_request_code = this.$route.params.id
            this.disabled_button = true
        }

        if (this.device_request_code != "" || this.device_request_code != null) {
            console.log(this.device_request_code)
            let urlDevReq = url.svd.device_request_new.list + "?page=1" + "&limit=1&request_code=" + this.device_request_code;
            AxiosCall.Get(urlDevReq).then((result) => {
                for (let data of result.data.data) {
                    this.isHidden = false
                    this.selected_merchant = data.merchants.full_name
                    this.selected_type = data.device_type.name
                    this.device_quantity = data.device_qty
                }
            })
        }
        AxiosCall.Get(url.svd.merchant.list).then((result) => {
            this.merchant_list = []
            for (let data of result.data) {
                let depth = '- '
                data.label = depth.repeat(data.depth) + data.full_name
                this.merchant_list.push(data)
            }
        })

        AxiosCall.Get(url.svd.device_type.selection).then(resp => {
            if (resp.code == 200) {
                for (let data of resp.data) {
                    data.label = data.name
                    delete data.name
                    this.device_type.push(data)
                }
            } else {
                this.warning("Get device type", "Fail get device type");
            }
        })

        this.gridApi = this.gridOptions.api;
        this.gridOptions.getRowStyle = function (params) {
            if (params.node.rowIndex % 2 === 0) {
                return { background: '#f9f9f9' }
            }
        }

        this.$root.$on("scan-from-ScanAgGridComponent", (data) => {
            this.updateSerial(data)
        })

        this.$root.$on("get-config-DeviceRequestGetConfig", (data) => {
            this.updateConfig(data)
        })

        this.$root.$on("get-config-DeviceRequestSerialNumber", (data) => {
            this.updateSerialNumber(data)
            // let serialData = {
            //   index: data.rowIndex,
            //   value: data.serial_number
            // }
            // this.updateSerial(serialData)
        })
    }
}
</script>

<style>
.cell-wrap-text {
    white-space: pre-wrap !important;
}

.overflow-wrap-break {
    overflow-wrap: break-word !important;
    word-wrap: break-word !important;
    hyphens: auto !important;
}

.text-small {
    font-size: 0.75em;
}
</style>
